import { type useQuery } from '@apollo/client/react';
import { createContext } from 'react';

import { type Company, type GetCurrentUserQuery } from '@/graphql/generated/graphql';

interface CurrentUserContextValueType {
  currentUser: GetCurrentUserQuery['fetchMyData'] | undefined;
  refetchCurrentUser: ReturnType<typeof useQuery<GetCurrentUserQuery>>['refetch'] | undefined;
  currentCompany: Partial<Company> | null | undefined;
  loadingCurrentUser: boolean;
  dashboardLayout: string[];
  dateTimePreference: { date?: string; time?: string };
}

const CurrentUserContext = createContext<CurrentUserContextValueType>({
  currentUser: undefined,
  currentCompany: null,
  refetchCurrentUser: undefined,
  loadingCurrentUser: true,
  dashboardLayout: [''],
  dateTimePreference: {},
});

export default CurrentUserContext;
